











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { PoiImage } from '@/models/poi';
import { urlize } from '@/utils';

@Component
export default class PoiSlideImage extends Vue {

    @Prop(Object) public model: PoiImage;
    @Prop({ default: false }) public useLargeImage: boolean;

    get aspectClass() {
        const classMapping = {
            ASPECT_FILL: 'aspect-fill',
            ASPECT_FIT: 'aspect-fit',
        };

        if (this.model.aspect in classMapping) {
            return classMapping[this.model.aspect];
        }

        return undefined;
    }

    get imgAlt() {
        if (!this.model.image.medium) return;
        const paths = this.model.image.medium.split('/');
        if (paths.length <= 0) return;
        const fileName = paths[paths.length - 1];

        return fileName;
    }

    get imageUrl() {
        if (this.useLargeImage) {
            return urlize(this.model.image.large);
        } else {
            return urlize(this.model.image.medium);
        }
    }
}
